
import { Link } from 'react-router-dom';

export default function ServicesPage() {
  return (
    <div className="min-h-screen relative">
      {/* 3D Globe Background for entire page */}
      <div className="fixed inset-0 z-0">
        <iframe 
          src='https://my.spline.design/3dglobe-p3XQBgXXJW2L7fmP5LlHN6Xc/' 
          frameBorder='0' 
          width='100%' 
          height='100%'
          className="w-full h-full"
        />
      </div>
      
      {/* Overlay for better content readability */}
      <div className="fixed inset-0 bg-black/40 z-10"></div>
      
      {/* All page content */}
      <div className="relative z-20">
        {/* Hero Section */}
        <section className="py-20 pt-32">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center">
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 drop-shadow-2xl">
                Our Services
              </h1>
              <p className="text-xl text-white/90 max-w-4xl mx-auto leading-relaxed drop-shadow-lg">
                Comprehensive digital solutions designed to transform your business and drive sustainable growth across all channels.
              </p>
            </div>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Marketing */}
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-2xl hover:bg-white/15 transition-all duration-300 cursor-pointer border border-white/20">
                <div className="w-16 h-16 bg-blue-500/20 backdrop-blur-md rounded-full flex items-center justify-center mb-6 border border-blue-300/30">
                  <i className="ri-megaphone-line text-2xl text-blue-300"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 drop-shadow-lg">Digital Marketing</h3>
                <p className="text-white/80 mb-6 leading-relaxed drop-shadow-md">
                  Comprehensive digital marketing strategies including SEO, PPC, content marketing, social media management, and email campaigns designed to maximize your online visibility and ROI.
                </p>
                <ul className="text-white/70 space-y-2 mb-6 text-sm">
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Search Engine Optimization (SEO)</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Pay-Per-Click Advertising (PPC)</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Content Marketing Strategy</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Social Media Management</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Email Marketing Automation</li>
                </ul>
                <Link to="/contact" className="text-blue-300 font-semibold hover:text-blue-200 cursor-pointer drop-shadow-md">
                  Get Started →
                </Link>
              </div>

              {/* AI Integration */}
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-2xl hover:bg-white/15 transition-all duration-300 cursor-pointer border border-white/20">
                <div className="w-16 h-16 bg-purple-500/20 backdrop-blur-md rounded-full flex items-center justify-center mb-6 border border-purple-300/30">
                  <i className="ri-robot-line text-2xl text-purple-300"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 drop-shadow-lg">AI Integration</h3>
                <p className="text-white/80 mb-6 leading-relaxed drop-shadow-md">
                  Cutting-edge AI solutions including intelligent chatbots, automated content generation, predictive analytics, and machine learning implementations.
                </p>
                <ul className="text-white/70 space-y-2 mb-6 text-sm">
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>AI-Powered Chatbots</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Content Generation Tools</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Predictive Analytics</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Machine Learning Models</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Process Automation</li>
                </ul>
                <Link to="/contact" className="text-purple-300 font-semibold hover:text-purple-200 cursor-pointer drop-shadow-md">
                  Explore AI →
                </Link>
              </div>

              {/* Reputation Management */}
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-2xl hover:bg-white/15 transition-all duration-300 cursor-pointer border border-white/20">
                <div className="w-16 h-16 bg-yellow-500/20 backdrop-blur-md rounded-full flex items-center justify-center mb-6 border border-yellow-300/30">
                  <i className="ri-star-line text-2xl text-yellow-300"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 drop-shadow-lg">Reputation Management</h3>
                <p className="text-white/80 mb-6 leading-relaxed drop-shadow-md">
                  Comprehensive reputation management services including negative content removal, search result optimization, and proactive brand protection strategies.
                </p>
                <ul className="text-white/70 space-y-2 mb-6 text-sm">
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Negative Content Removal</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Search Result Deindexing</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Crisis Management</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Brand Monitoring</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-400 mr-2"></i>Review Management</li>
                </ul>
                <Link to="/contact" className="text-yellow-300 font-semibold hover:text-yellow-200 cursor-pointer drop-shadow-md">
                  Protect Brand →
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Service Categories Table */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white mb-6 drop-shadow-2xl">Service Categories & Key Offerings</h2>
              <p className="text-xl text-white/90 max-w-3xl mx-auto drop-shadow-lg">
                Comprehensive overview of our specialized services across all digital domains
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-2xl border border-white/20 overflow-x-auto">
              <div className="min-w-full">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  <div className="space-y-6">
                    <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 border border-white/10">
                      <h3 className="text-xl font-bold text-blue-300 mb-4 flex items-center">
                        <i className="ri-megaphone-line mr-3"></i>Marketing
                      </h3>
                      <p className="text-white/80 text-sm leading-relaxed">
                        SEO, Paid Search & SEM, PPC, Content Marketing, Social Media Marketing, Email Marketing
                      </p>
                    </div>

                    <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 border border-white/10">
                      <h3 className="text-xl font-bold text-green-300 mb-4 flex items-center">
                        <i className="ri-team-line mr-3"></i>Affiliates
                      </h3>
                      <p className="text-white/80 text-sm leading-relaxed">
                        Offer Generation, All-in-One CRM & Tracking, Training and Support
                      </p>
                    </div>

                    <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 border border-white/10">
                      <h3 className="text-xl font-bold text-yellow-300 mb-4 flex items-center">
                        <i className="ri-star-line mr-3"></i>Reputation Management
                      </h3>
                      <p className="text-white/80 text-sm leading-relaxed">
                        Negative Content Removal, Deindexing, Positive Content Promotion, Crisis Management
                      </p>
                    </div>

                    <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 border border-white/10">
                      <h3 className="text-xl font-bold text-orange-300 mb-4 flex items-center">
                        <i className="ri-store-line mr-3"></i>My Business
                      </h3>
                      <p className="text-white/80 text-sm leading-relaxed">
                        Online Review Management, CTR Improvement, Google Maps & GPS Rankings
                      </p>
                    </div>
                  </div>

                  <div className="space-y-6">
                    <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 border border-white/10">
                      <h3 className="text-xl font-bold text-purple-300 mb-4 flex items-center">
                        <i className="ri-robot-line mr-3"></i>Artificial Intelligence
                      </h3>
                      <p className="text-white/80 text-sm leading-relaxed">
                        AI Bots, Content Creation, AI Code Assessment & Writing, Machine Learning
                      </p>
                    </div>

                    <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 border border-white/10">
                      <h3 className="text-xl font-bold text-cyan-300 mb-4 flex items-center">
                        <i className="ri-computer-line mr-3"></i>Platforms
                      </h3>
                      <p className="text-white/80 text-sm leading-relaxed">
                        CRM, CMS, Advanced Digital Platforms
                      </p>
                    </div>

                    <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 border border-white/10">
                      <h3 className="text-xl font-bold text-emerald-300 mb-4 flex items-center">
                        <i className="ri-government-line mr-3"></i>Government Solutions
                      </h3>
                      <p className="text-white/80 text-sm leading-relaxed">
                        Trade License Services, External Approvals, Business Compliance, Ejari Services
                      </p>
                    </div>

                    <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 border border-white/10">
                      <h3 className="text-xl font-bold text-rose-300 mb-4 flex items-center">
                        <i className="ri-hashtag mr-3"></i>Social Media
                      </h3>
                      <p className="text-white/80 text-sm leading-relaxed">
                        Verifications, Username Claims, Influencer Engagement, Unban Support, Organic Growth
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Detailed Service Breakdown */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white mb-6 drop-shadow-2xl">Detailed Service Breakdown</h2>
              <p className="text-xl text-white/90 max-w-3xl mx-auto drop-shadow-lg">
                In-depth exploration of our flagship services and specialized solutions
              </p>
            </div>

            <div className="space-y-16">
              {/* Viralmaind Marketing Revolution */}
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-2xl border border-white/20">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-blue-500/20 backdrop-blur-md rounded-full flex items-center justify-center mr-6 border border-blue-300/30">
                    <i className="ri-megaphone-line text-2xl text-blue-300"></i>
                  </div>
                  <div>
                    <h3 className="text-3xl font-bold text-white drop-shadow-lg">Viralmaind Marketing Revolution</h3>
                    <p className="text-blue-300 text-lg font-semibold">Revolutionize Your Brand's Reach with us Marketing Mastery</p>
                  </div>
                </div>
                
                <p className="text-white/80 mb-6 leading-relaxed">
                  Viralmaind marketing represents the forefront of digital advertising, delivering streamed content directly to viewers via internet-connected devices, bypassing traditional cable or broadcast television. This innovative approach allows us to reach audiences while they stream content on platforms like Netflix, Amazon Prime Video, and other major streaming services.
                </p>

                <h4 className="text-xl font-bold text-white mb-4">Viralmaind Solutions Include:</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white/5 backdrop-blur-md rounded-xl p-4 border border-white/10">
                    <h5 className="font-semibold text-blue-300 mb-2">Strategic Audience Reach</h5>
                    <p className="text-white/70 text-sm">Successfully connect with cord-cutters and streaming-first audiences through precise Viralmaind targeting</p>
                  </div>
                  <div className="bg-white/5 backdrop-blur-md rounded-xl p-4 border border-white/10">
                    <h5 className="font-semibold text-blue-300 mb-2">Measurable Outcomes</h5>
                    <p className="text-white/70 text-sm">Leverage advanced attribution to monitor viewer engagement with ads and content across different devices</p>
                  </div>
                  <div className="bg-white/5 backdrop-blur-md rounded-xl p-4 border border-white/10">
                    <h5 className="font-semibold text-blue-300 mb-2">Ad Podding Innovation</h5>
                    <p className="text-white/70 text-sm">Group multiple ads back-to-back during commercial breaks to enhance viewing efficiency and user experience</p>
                  </div>
                  <div className="bg-white/5 backdrop-blur-md rounded-xl p-4 border border-white/10">
                    <h5 className="font-semibold text-blue-300 mb-2">Cross-Channel Integration</h5>
                    <p className="text-white/70 text-sm">Combine Viralmaind attribution data with insights from other channels to create a holistic view of the user journey</p>
                  </div>
                </div>
              </div>

              {/* Artificial Intelligence Integration */}
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-2xl border border-white/20">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-purple-500/20 backdrop-blur-md rounded-full flex items-center justify-center mr-6 border border-purple-300/30">
                    <i className="ri-robot-line text-2xl text-purple-300"></i>
                  </div>
                  <div>
                    <h3 className="text-3xl font-bold text-white drop-shadow-lg">Artificial Intelligence Integration</h3>
                    <p className="text-purple-300 text-lg font-semibold">Transform Business Operations with AI-Powered Solutions</p>
                  </div>
                </div>
                
                <p className="text-white/80 mb-6 leading-relaxed">
                  Harness the power of artificial intelligence to revolutionize your business operations, elevate decision-making processes, and craft unparalleled customer experiences.
                </p>

                <h4 className="text-xl font-bold text-white mb-4">Our AI Capabilities:</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white/5 backdrop-blur-md rounded-xl p-4 border border-white/10">
                    <h5 className="font-semibold text-purple-300 mb-2">AI Bots</h5>
                    <p className="text-white/70 text-sm">Enhance customer interactions, streamline sales processes, and drive unparalleled business growth through intelligent automation</p>
                  </div>
                  <div className="bg-white/5 backdrop-blur-md rounded-xl p-4 border border-white/10">
                    <h5 className="font-semibold text-purple-300 mb-2">AI Content Creation</h5>
                    <p className="text-white/70 text-sm">Redefine content generation in the digital era using advanced AI tools that produce high-quality, engaging material</p>
                  </div>
                  <div className="bg-white/5 backdrop-blur-md rounded-xl p-4 border border-white/10">
                    <h5 className="font-semibold text-purple-300 mb-2">AI Code Assessment & Writing</h5>
                    <p className="text-white/70 text-sm">Enhance efficiency, accuracy, and coding standards in software development through intelligent code analysis and generation</p>
                  </div>
                  <div className="bg-white/5 backdrop-blur-md rounded-xl p-4 border border-white/10">
                    <h5 className="font-semibold text-purple-300 mb-2">Machine Learning Implementation</h5>
                    <p className="text-white/70 text-sm">Deploy predictive analytics and machine learning algorithms to gain deeper insights into consumer behavior and market trends</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white mb-6 drop-shadow-2xl">Our Process</h2>
              <p className="text-xl text-white/90 max-w-3xl mx-auto drop-shadow-lg">
                A proven methodology that delivers consistent results
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-blue-500/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6 border border-blue-300/30">
                  <span className="text-2xl font-bold text-blue-300">1</span>
                </div>
                <h3 className="text-xl font-bold text-white mb-4 drop-shadow-lg">Discovery</h3>
                <p className="text-white/80 drop-shadow-md">Understanding your business goals and current challenges</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-purple-500/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6 border border-purple-300/30">
                  <span className="text-2xl font-bold text-purple-300">2</span>
                </div>
                <h3 className="text-xl font-bold text-white mb-4 drop-shadow-lg">Strategy</h3>
                <p className="text-white/80 drop-shadow-md">Developing a customized digital growth plan</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-green-500/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6 border border-green-300/30">
                  <span className="text-2xl font-bold text-green-300">3</span>
                </div>
                <h3 className="text-xl font-bold text-white mb-4 drop-shadow-lg">Implementation</h3>
                <p className="text-white/80 drop-shadow-md">Executing the strategy with precision and expertise</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-orange-500/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6 border border-orange-300/30">
                  <span className="text-2xl font-bold text-orange-300">4</span>
                </div>
                <h3 className="text-xl font-bold text-white mb-4 drop-shadow-lg">Optimization</h3>
                <p className="text-white/80 drop-shadow-md">Continuous monitoring and improvement for maximum ROI</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto text-center px-6">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 drop-shadow-2xl">
              Ready to Transform Your Business?
            </h2>
            <p className="text-xl text-white/90 mb-8 drop-shadow-lg">
              Get your personalized digital growth plan and start scaling today.
            </p>
            <Link 
              to="/contact" 
              className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 shadow-2xl whitespace-nowrap cursor-pointer inline-block"
            >
              Get My Growth Plan
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}